import { render } from "./ProductDetailsSetItems.vue?vue&type=template&id=044cd7be"
import script from "./ProductDetailsSetItems.vue?vue&type=script&lang=js"
export * from "./ProductDetailsSetItems.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__